"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import { useCallback, useEffect, useRef, useState } from "react";
import { mainNavigation } from "@lib/navigation";
import TabEntry from "./tab-entry";
const SCROLL_STEP = 300;
const leftDivId = "navbar-left-boundary";
const rightDivId = "navbar-right-boundary";
export default function TabNavigation() {
  const $ = _c(12);
  const leftDivRef = useRef(null);
  const rightDivRef = useRef(null);
  const [showLeftButton, setShowLeftButton] = useState(false);
  const [showRightButton, setShowRightButton] = useState(false);
  const navRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      navRef.current?.scrollBy({
        left: SCROLL_STEP
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleScrollRight = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      navRef.current?.scrollBy({
        left: -SCROLL_STEP
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleScrollLeft = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!leftDivRef.current || !rightDivRef.current) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target.id === rightDivId) {
            if (entry.isIntersecting) {
              setShowRightButton(false);
              return;
            }
            setShowRightButton(true);
          }
          if (entry.target.id === leftDivId) {
            if (entry.isIntersecting) {
              setShowLeftButton(false);
              return;
            }
            setShowLeftButton(true);
          }
        });
      });
      observer.observe(leftDivRef.current);
      observer.observe(rightDivRef.current);
      return () => {
        observer.disconnect();
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== showLeftButton) {
    t4 = showLeftButton ? <button className="h-14 w-20" onClick={handleScrollLeft} aria-label={"Scrolla v\xE4nster"}><ArrowLeftIcon className="m-auto h-6 w-6" /></button> : <div className="h-14 w-20" />;
    $[4] = showLeftButton;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <nav className="scrollbar-hide flex gap-3 overflow-x-scroll scroll-smooth text-center" ref={navRef}><div id={leftDivId} ref={leftDivRef} />{mainNavigation.map(item => <TabEntry key={item.title} item={item} navRef={navRef} />)}<div id={rightDivId} className="min-w-[1px]" ref={rightDivRef} /></nav>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== showRightButton) {
    t6 = showRightButton ? <button className="h-14 w-20" onClick={handleScrollRight} aria-label={"Scrolla h\xF6ger"}><ArrowRightIcon className="m-auto h-6 w-6" /></button> : <div className="h-14 w-20" />;
    $[7] = showRightButton;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="hidden items-end sm:flex">{t4}{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}